module.exports = __webpack_public_path__ + "media/images/design/sizeM-a4dbe8ac01c747eb01bf7c3d26ec1df5.png";